import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import app from '../../main'
import Crud from '../crud'
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  customer_id: payload.customer_id,
  delivery_address: payload.delivery_address
})
var crud = new Crud('Projects', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  projects: [],
  catalog: {
    customers: [],
    currencies: []
  },
  details: [],
  isModalCustomerPurchaseOrderVisible: false
}

const mutations = {
  ...crud.mutations,
  SET_MODAL_CUSTOMER_PURCHASE_ORDER_VISIBLE (state, payload) {
    state.isModalCustomerPurchaseOrderVisible = payload
  },
  SET_PRODUCT_DETAIL (state, payload) {
    state.details = payload
  },
  SET_DETAILS_IMPORT (state, payload) {
    state.details.push(...payload)
  }
}

const actions = {
  ...crud.actions,
  setModalCustomerPurchaseOrderVisible ({ commit }, payload) {
    commit('SET_MODAL_CUSTOMER_PURCHASE_ORDER_VISIBLE', payload)
  },
  async addPurchaseOrder ({ commit }, payload) {
    app.$Progress.start()

    try {
      const response = await axios.post('customer-purchase-orders', payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_CUSTOMER_PURCHASE_ORDER_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.customer_purchase_order', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async makeRecordsFromExcel ({ commit }, payload) {
    let formData = new FormData()
    formData.append('file', payload.file[0])
    formData.append('id', payload.id)

    app.$Progress.start()
    try {
      const response = await axios.post(`customer-purchase-orders/details/file`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_DETAILS_IMPORT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  downloadTemplate ({ dispatch }, payload) {
    dispatch('CustomerPurchaseOrders/downloadTemplate', payload, { root: true })
  },
  setProductDetails ({ commit }, payload) {
    commit('SET_PRODUCT_DETAIL', payload)
  }
}

const getters = {
  ...crud.getters,
  projects: state => state.projects,
  details: state => state.details,
  isModalCustomerPurchaseOrderVisible: state => state.isModalCustomerPurchaseOrderVisible
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
